import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../../';

export const selectCategories = (state: RootState) => state.helpCenter.categories;
export const selectTopics = (state: RootState) => state.helpCenter.topics;
export const selectVoted = (state: RootState) => state.helpCenter.voted;
export const selectLoading = (state: RootState) => state.helpCenter.loading;

export const grandCategoriesSelector = createSelector(selectCategories, (categories) =>
  categories.filter((category) => !category.parentId),
);

export const grandCategoryBySlugSelector = createSelector(
  [selectCategories, (_, slug) => slug],
  (categories, slug) => categories.find((category) => category.slug === slug && !category.parentId),
);

export const categoriesByGrandSelector = createSelector(
  [selectCategories, (_, grandCategoryId) => grandCategoryId],
  (categories, grandCategoryId) =>
    categories.filter((category) => category.parentId === grandCategoryId),
);

export const categoryBySlugSelector = createSelector(
  [selectCategories, (_, slug) => slug],
  (categories, slug) => categories.find((el) => el.slug === slug),
);

export const topicsByCategorySlugSelector = createSelector(
  [selectTopics, (_, categorySlug) => categorySlug],
  (topics, categorySlug) => topics[categorySlug] || [],
);

export const topicsToArraySelector = createSelector(selectTopics, (topics) =>
  Object.values(topics).reduce((acc, val) => acc.concat(val), []),
);

export const topicBySlugSelector = createSelector(
  [topicsByCategorySlugSelector, (_, __, topicSlug) => topicSlug],
  (topics, topicSlug) => topics.find((topic) => topic.slug === topicSlug),
);

export const isClickedUsefulTopicSelector = createSelector(
  [selectVoted, (_, slug) => slug],
  (voted, slug) => voted.includes(slug),
);
